import { getShopProductDetail } from '@/apis/associated'
import { productDetail } from '@/apis/search'
import { searchOemDetail, searchCombineProductApi, searchGoodsApi } from '@/apis/goods'
import { mockData } from './mock'
import { ref } from 'vue'
import { isJA } from '@/store'
interface SKUTYPE {
  shopItemId: string,
  shopItemSkuId: string,
  activeProduct: {
    productCode: string,
    productSku: string,
    productType: number
  }
}
interface PRODUTTYPE {
  productCode: string,
  productType: string,
  shopSkuList: SKUTYPE[]
}
export default async (shopItemId: string) => {
  return await getShopProductDetail({
    shopItemId: shopItemId
  }).then(async (res) => {
    const data = await getShopSkuMappingProductSku(res.data.skuList)
    return {
      // 店铺商品
      shopDetail: res.data,
      // 平台商品列表
      productList: data.productList
    }
  })
}

// 整理供货商品列表数据按商品纬度展示
const getShopSkuMappingProductSku = async (skuList:any) => {
  const productList:any = []
  skuList.forEach((item:any) => {
    item.skuMappingList?.forEach((temp:any, index:number) => {
      if (!temp.productCode) return
      if (!productList[index]) {
        productList[index] = {
          productCode: temp.productType === 2 ? temp.productSku : temp.productCode,
          productType: temp.productType,
          shopSkuList: skuList.map((skuItem:any, key:number) => {
            return {
              ...skuItem,
              activeProduct: skuItem.skuMappingList[index]
            }
          })
        }
      }
      if (!productList[index].productCode) {
        temp.productCode && (productList[index].productCode = temp.productType === 2 ? temp.productSku : temp.productCode)
        temp.productType && (productList[index].productType = temp.productType)
      }
    })
  })
  const procuctDetailList = productList.filter((i:any) => i.productCode)
  console.log('procuctDetailList', procuctDetailList)
  const productDetails = await Promise.all(procuctDetailList.map((i:any) => {
    return getProductDetail(i)
  })) ?? []
  return {
    productList: productList.map((i:any, key:any) => {
      const a:any = productDetails[key] ?? {}
      return {
        ...i,
        ...a
      }
    })
  }
}
// 获取商品信息
export const getProductDetail = async (item: {productCode: string, productType: number, productSku?: string}) => {
  console.log('获取商品信息', item)
  if (item.productType === 1) {
    // 普通商品
    const detail = await searchGoodsApi({
      productCode: item.productCode
    }).then((res) => res.data ?? {})
    detail.productType = 1
    detail.productPropGroupList = (detail.productPropGroupJaList?.length > 0 && isJA()) ? detail.productPropGroupJaList : detail.productPropGroupList
    // 优先取线上sku
    const skuList = detail.skuList.filter((v:any) => v.isOnlineSku === 1)
    detail.skuList.forEach((item:any) => {
      if (!skuList.find((v:any) => v.productProperties === item.productProperties)) {
        skuList.push(item)
      }
    })
    return {
      ...detail,
      skuList
    }
  } else if (item.productType === 2) {
    // oem
    const detail = await searchOemDetail({
      productSku: item.productSku ?? item.productCode
    }).then((res) => res.data)
    return changeProductObj(2, {
      ...detail,
      productSku: item.productSku ?? item.productCode
    })
  } else if (item.productType === 3) {
    // 组合
    const detail = await searchCombineProductApi({
      combinationProductSku: item.productCode ?? item.productSku
    }).then((res) => res.data)
    console.log(detail)
    return changeProductObj(3, detail)
  }
}
export const getNewProductList = ({ oldProductList, productIndex, shopSkuIndex, productSku, isUnbind }:{oldProductList:PRODUTTYPE[], productIndex:number, shopSkuIndex:number, productSku:string, isUnbind?:boolean}) => {
  const list = JSON.parse(JSON.stringify(oldProductList))
  list[productIndex].shopSkuList[shopSkuIndex].activeProduct = isUnbind ? {} : list[productIndex].skuList.find((i:{productSku:string}) => i.productSku === productSku)
  return list
}
const handleData = (list:PRODUTTYPE[]) => {
  // 先重新处理新数据前排为空的情况
  const newProductList:any = []
  list.forEach((item:any) => {
    // 如果商品内有关联的sku则加入
    if (item?.shopSkuList?.find((i:any) => i?.activeProduct?.productSku)) {
      newProductList.push(item)
    }
  })
  return newProductList
}
const getReqData = (productList:PRODUTTYPE[], keys: number[], oldProductList:PRODUTTYPE[]) => {
  const shopSkuList = oldProductList[0]?.shopSkuList ?? []
  const skuMappingList:any = []
  const shopItemId:any = shopSkuList[0]?.shopItemId
  keys.forEach((itemIndex) => {
    if (shopSkuList?.[itemIndex]?.shopItemSkuId) {
      const obj:any = {
        shopItemSkuId: shopSkuList?.[itemIndex]?.shopItemSkuId,
        mappingInfoList: []
      }
      productList.forEach((item) => {
        // shopItemId = item.shopSkuList[itemIndex].shopItemId
        // obj.shopItemSkuId = item.shopSkuList[itemIndex].shopItemSkuId
        const activeProduct = item.shopSkuList[itemIndex]?.activeProduct ?? {}
        obj.mappingInfoList.push(activeProduct.productSku ? {
          productCode: item.productCode,
          productSku: activeProduct.productSku,
          productType: item.productType
        } : {})
      })
      skuMappingList.push(obj)
    }
  })
  console.log('reqData', {
    shopItemId,
    skuMappingList
  })
  return {
    shopItemId,
    skuMappingList
  }
}
export const diffProductList = (oldProductList:PRODUTTYPE[], newProductList:PRODUTTYPE[]) => {
  const oldList = handleData(oldProductList)
  const newList = handleData(newProductList)
  // 变更的店铺sku
  const diffShopKeyList:number[] = []
  const oldL = oldList.length > newList.length ? oldList : newList
  const newL = oldList.length > newList.length ? newList : oldList
  oldL.forEach((item:PRODUTTYPE, index:number) => {
    item?.shopSkuList.forEach((temp:SKUTYPE, key:number) => {
      if (temp.activeProduct.productSku !== newL[index]?.shopSkuList?.[key]?.activeProduct?.productSku) {
        if (!diffShopKeyList.includes(key)) {
          diffShopKeyList.push(key)
        }
      }
    })
  })
  console.log('newListsss', newList, diffShopKeyList)
  return getReqData(newList, diffShopKeyList, oldProductList)
}

// 整理oem组合商品数据格式化和普通商品格式一致
export const changeProductObj = (productType:number, product:any) => {
  if (productType === 2) {
    return {
      ...product,
      productCode: product.searchSourceOrderNo,
      productSku: product.productSku,
      productTitle: product.productName,
      productMainImg: product.productImg,
      productType: 2,
      productPropGroupList: [
        {
          type: '',
          props: product.searchSourceOrderSkuResp?.map((item:any) => {
            return {
              propKey: item.productSku,
              propValue: item.color + item.size
            }
          })
        }
      ],
      skuList: product.searchSourceOrderSkuResp?.map((item:any) => {
        return {
          productType: 2,
          productSku: item.productSku,
          productProperties: item.productSku,
          productSellPrice: product.biggestprice ?? 0,
          productPropertiesName: item.color + item.size
        }
      })
    }
  } else if (productType === 3) {
    return {
      ...product,
      productCode: product.combinationProductSku,
      productSku: product.combinationProductSku,
      productTitle: product.combinationProductName,
      productMainImg: product.combinationProductMainImg,
      productType: 3,
      productPropGroupList: [
        {
          type: '',
          props: [
            {
              propKey: product.combinationProductProp,
              propValue: product.combinationProductProp
            }
          ]
        }
      ],
      skuList: [
        {
          productType: 3,
          productSku: product.combinationProductSku,
          productProperties: product.combinationProductProp,
          productSellPrice: product.productSellPrice ?? product.unitPrice,
          productPropertiesName: product.combinationProductProp
        }
      ]
    }
  }
}
// const newList = getNewProductList({
//   oldProductList: mockData,
//   productIndex: 0,
//   shopSkuIndex: 1,
//   productSku: '平台商品1sku3'
// })
// diffProductList(mockData, newList)
